import { useMutation, useQueryClient } from '@tanstack/react-query'
import { ApiKey } from 'features/incidents/components/enums'
import { axios } from 'lib/axios'
import { endpoints } from 'utils/endpoints'

export const addService = (data: object) => {
  return axios.put(endpoints.addService, data)
}
export const useAddService = () => {
  const client = useQueryClient()

  return useMutation(addService, {
    onSuccess: () => {
      client.invalidateQueries([ApiKey.policies, ApiKey.list])
    },
  })
}
